<template>
  <!-- 會議條碼 列印頁 -->
  <div
    id="printAttendanceCard"
    ref="printPage"
  >
    <!-- 只是八個八個一組，多一層包在外面而已 -->
    <div
      v-for="page in pages"
      :key="page[0].barcode"
      class="page"
    >
      <div
        v-for="card in page"
        :key="card.barcode"
        class="card"
      >
        <div class="nav">
          <div class="communityArea">
            <img
              class="logo"
              src="@/assets/img/unitOwnerAssembly/attendanceCard/IanLaiVote.svg"
              alt="voteIcon"
            >
            <div class="name">
              {{ communityName }}
            </div>
          </div>
          <img
            class="smartDailyArea"
            src="@/assets/img/unitOwnerAssembly/attendanceCard/smartDaily.svg"
            alt="logo"
          >
        </div>
        <div
          v-if="1"
          class="content-container"
        >
          <div class="content">
            <div class="title">
              報到單
            </div>
            <div class="assemblyName">
              {{ assemblyTitle }}
            </div>
            <div class="address">
              {{ card.tabletName }}
            </div>
          </div>
        </div>
        <div class="barcode">
          <VueBarcode
            :value="card.barcode"
            :options="barcodeOptions"
            tag="img"
          />
        </div>
        <div class="footer">
          <img
            class="footerImg"
            src="@/assets/img/unitOwnerAssembly/attendanceCard/footer.svg"
            alt="footer"
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueBarcode from '@chenfengyuan/vue-barcode'
import { getBarcodeOptionsByDigit } from '../../utils/UnitOwnerAssemblyUtils'
import { groupArrItems } from '../../utils'
export default {
  components: {
    VueBarcode
  },
  data () {
    const pages = []
    return {
      pages,
      communityName: JSON.parse(localStorage.getItem('loginUserInfo')).CommunityName,
      barcodeOptions: null,
      array: [],
      assemblyTitle: ''
    }
  },
  computed: {
  },
  methods: {
    // 列印
    print (assemblyId, title) {
      this.fullScreenLoading(true)
      this.assemblyTitle = title
      apiUnitOwnerAssembly.Print.GetAttendanceCardList(
        {
          AssemblyId: assemblyId
        }
      ).then(res => {
        this.array = res.data
        // 整筆資料 barcode 長度都一樣，取第一個確認長度即可
        this.barcodeOptions = getBarcodeOptionsByDigit(this.array[0].barcode.length, 'attendance')
        console.log('會議條碼', this.array)
        this.array.forEach(item => {
          item.areaRatio = (item.areaRatio * 100).toFixed(2)
        })
        this.pages = groupArrItems(this.array, 8)
        setTimeout(() => {
          this.$print(this.$refs.printPage)
          this.fullScreenLoading(false)
        }, 300)
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
        if (err.response.status >= 400) {
          this.fullScreenLoading(false)
          this.$message({
            message: '取得會議條碼失敗，請稍後再試',
            type: 'warning'
          })
        }
      })
    },
    // 全屏loading畫面
    fullScreenLoading (display) {
      const loadingWrap = this.$loading({
        lock: true,
        text: '資料處理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (!display) { loadingWrap.close() }
    }
  }
}
</script>
<style lang="sass" scoped>
*
  // border: 1px solid red;
body
  margin: 0
@page
  size: A4 portrait
@media print
  *
    // 父層有一個 line-height: 1 的屬性，拿掉會影響 funcWrap，有會影響列印排版
    line-height: unset !important
@media print, screen
  *
    -webkit-print-color-adjust: exact !important
  #printAttendanceCard
    width: 210mm
    text-align: start
    // height: 297mm
    .card
      page-break-before: always
      width: 50%
      height: calc(297mm / 4)
      // display: flex;
      display: inline-flex
      flex-direction: column
      align-items: center
      border: dashed 0.4px #e1e1e1
      box-sizing: border-box
      .nav
        display: flex
        width: 100%
        height: 43px
        justify-content: space-between
        align-items: center
        padding: 0 32px
        box-sizing: border-box
        .communityArea
          display: flex
          align-items: center
          gap: 8px
          .logo
            width: 28px
            height: 31px
          .name
            font-weight: 600
            font-size: 17px
            color: $mainFontColor

        .smartDailyArea
          width: 80px
          height: 25.2px
      .content-container
        height: 146px
        width: 100%
        padding: 0 16px
        box-sizing: border-box
        .content
          width: 100%
          height: 100%
          border-radius: 20px
          border: solid 2px $bgDarkBg
          display: flex
          flex-direction: column
          align-items: center
          padding-top: 10px
          box-sizing: border-box
          gap: 12px
          .title
            width: 100%
            font-weight: 600
            font-size: 22px
            text-align: center
            color: $mainFontColor
          .assemblyName
            text-overflow: ellipsis
            overflow: hidden
            white-space: nowrap
            width: 100%
            padding: 0 12px
            box-sizing: border-box
            align-items: center
            font-weight: 600
            font-size: 20px
            text-align: center
            color: $darkGrayFontColor
          .address
            text-overflow: ellipsis
            overflow: hidden
            white-space: nowrap
            width: 100%
            padding: 0 10px
            box-sizing: border-box
            font-weight: 600
            font-size: 22px
            text-align: center
            color: $mainFontColor
      .barcode
        width: 100%
        height: 50px
        display: flex
        justify-content: center
        align-items: center
        overflow: hidden
        margin-top: 10px
      .footer
        flex-grow: 1
        width: 100%
        display: flex
        align-items: center
        justify-content: center
        .footerImg
          height: 17px
          width: 312px
@media  screen
  #printAttendanceCard
    display: none
</style>
